import ProductCardWishlist from 'Component/ProductCardWishlist';
import { SharedWishlistItem as SourceSharedWishlistItem } from 'SourceComponent/SharedWishlistItem/SharedWishlistItem.component';

import './SharedWishlistItem.style';

/** @namespace Pwa/Component/SharedWishlistItem/Component */
export class SharedWishlistItem extends SourceSharedWishlistItem {
    render() {
        const { product, isLoading } = this.props;

        return <ProductCardWishlist product={product} isLoading={isLoading} mix={{ block: 'ProductCardWishlist' }} />;
    }
}

export default SharedWishlistItem;
